(() => {
  const bar = document.querySelector('.ap-sticky-atc');
  const trigger = document.querySelector('.product-form__buttons') || document.querySelector('product-form');
  const mainBtn = document.querySelector('.product-form__submit');

  if (!bar || !trigger || !mainBtn) return;

  // Click en la barra -> click en el botón real
  bar.querySelector('.ap-sticky-atc__btn')?.addEventListener('click', (e) => {
    e.preventDefault();
    mainBtn.click();
  });

  // Mostrar cuando el bloque del botón principal ya no se ve
  const obs = new IntersectionObserver(
    (entries) => {
      const isVisible = entries[0].isIntersecting;
      bar.classList.toggle('is-visible', !isVisible);
    },
    { threshold: 0.15 }
  );

  obs.observe(trigger);
})();
